<template>
  <div class="container o-form-page">
    <div v-if="item.code && hideCode" class="container-fixed">
      <p
        class="d-flex flex-row justify-content-between align-items-center mod-p"
      >
        {{ item.code }} | {{ item.description }}
        <template v-if="!!workflowInstance">
          <b-badge
            class="pl-2 mod-span"
            :key="index"
            v-for="(detail, index) in workflowInstanceDetail"
            variant="secondary"
            >{{ detail.state__name }}</b-badge
          >
        </template>
      </p>
    </div>
    <o-working-overlay :working="working"></o-working-overlay>

    <o-section :title="title" @click="enableDebug($event)" :level="0">
      <item-form
        :form-state="formState"
        :item="item"
        :server-errors="serverErrors"
        v-bind:create="create"
        @reload="reload"
        :_do-save="_doSave"
      ></item-form>
    </o-section>

    <o-action-buttons
      :item="item"
      :form-state="formState"
      :create="create"
      @save="doSave"
      @saveAndClose="doSaveAndClose"
      @saveAndNew="doSaveAndNew"
      @delete="doDeleteItem"
      :show-create-and-new="true"
    >
      <o-report-button
        v-if="itemParams"
        :filename="'Extra Details Report - ' + item.id + '.pdf'"
        report-name="extra_report"
        class="ml-2 my-2"
        :params="itemParams"
        variant=""
        >Download Extra</o-report-button
      >
    </o-action-buttons>
  </div>
</template>

<script>
import {
  CreateFormPageMixin,
  CreateGroupPermissionMixin,
  UnsavedMixin,
} from "../../../vue-ocom/mixins";
import ItemForm from "../components/ItemForm.vue";
import OActionButtons from "../../../vue-ocom/components/forms/OActionButtons";
import OSection from "../../../vue-ocom/components/layout/OSection";
import OWorkingOverlay from "../../../vue-ocom/components/OWorkingOverlay";
import _ from "lodash";
import OReportButton from "@/vue-ocom/reports/OReportButton";

export default {
  mixins: [
    UnsavedMixin,
    CreateFormPageMixin("ServiceExtra", "service_extra"),
    CreateGroupPermissionMixin("ServiceExtra"),
  ],
  components: {
    OReportButton,
    OSection,
    OWorkingOverlay,
    OActionButtons,
    ItemForm,
  },
  data() {
    return {
      hideCode: true,
    };
  },
  props: {
    create: { type: Boolean, default: false },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll(event) {
      if (window.scrollY <= 10) {
        this.hideCode = false;
      } else {
        this.hideCode = true;
      }
    },
  },
  computed: {
    itemParams() {
      if (this.item.id) {
        const item = {
          service_extra_id: this.item.id,
          file_server_url: "https://ocom-shojun-test.s3.amazonaws.com/",
        };
        return item;
      }

      return null;
    },
    workflowInstanceDetail() {
      let filteredState = _.filter(
        this.item.workflow_instance_details.states,
        function (state) {
          return state.is_active;
        }
      );

      let getFirstState = [];
      // if the filteredState.length > 0 then get only the first state
      if (filteredState.length > 0) {
        getFirstState.push(filteredState[0]);
        return getFirstState;
      }

      // if the filteredState is empty it means the state have a type of END so we need to determine if it is APPROVED or ONHOLD
      else if (filteredState.length <= 0) {
        const name = this.item.workflow_instance_details.workflow_status;
        // this.item.workflow_instance_details.workflow_status == "onhold"
        //   ? "On Hold"
        //   : "Approved";
        getFirstState.push({ state__name: name });
        return getFirstState;
      }

      return [];
    },
    workflowInstance() {
      return this.item.workflow_instance;
    },
    title() {
      if (this.create) {
        return "Create Extra";
      }

      return "Edit Extra";
    },
  },
};
</script>
<style scoped>
.mod-p {
  padding: 5px 30px 5px 30px;
}
.mod-span {
  font-size: initial;
}
.container-fixed {
  background: #3071a9;
  color: #fff;
  width: 1110px;
  border: 1px #3071a9 solid;
  position: fixed;
  top: 60px;
  z-index: 1000;
  margin-top: -10px;
}
.container-fixed p {
  margin: 0;
  line-break: anywhere;
}

@media screen and (max-width: 640px) {
  .action-buttons {
    margin-bottom: 20px;
  }

  .action-buttons div button {
    margin-bottom: 1px !important;
  }
}
</style>
